import styled from 'styled-components';
import { breakpoints, colors } from 'View/Theme';
import { asRem } from 'utils';

export default styled.div`
  margin-top: ${asRem(80)};
  margin-bottom: -${asRem(40)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${colors.sleep.blue.c600};
  color: ${colors.sleep.beige.c100};
  position: relative;
  padding: 0 !important;
  z-index: 100;
  cursor: pointer;

  &:focus-visible,
  &:hover {
    transform: translateY(-1px) scale(1.01);
    box-shadow: 0 2px 8px ${colors.black.o20};
  }

  @media (min-width: ${breakpoints.md}) {
    padding: ${asRem(20)} 0 0;
    margin-top: ${asRem(80)};
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    @media (min-width: ${breakpoints.md}) {
      flex-direction: row;
    }

    .text-wrapper {
      margin: 0 ${asRem(24)};
      flex: 2;
      padding: ${asRem(25)} 0 0;

      @media (min-width: ${breakpoints.md}) {
        margin: 0;
      }
    }

    .wrapper {
      display: none;
      flex: 0;
      align-items: center;
      height: ${asRem(115)};

      @media (min-width: ${breakpoints.md}) {
        display: flex;
      }
    }

    .left {
      justify-content: flex-end;
    }

    .right {
      justify-content: flex-start;
    }

    .mask-right,
    .mask-left {
      height: ${asRem(80)};

      @media (min-width: ${breakpoints.lg}) {
        height: ${asRem(100)};
      }
    }
  }

  .bf_mobile_images {
    display: flex;
    height: ${asRem(75)};
    margin-top: -${asRem(15)};
    margin-bottom: ${asRem(8)};

    @media (min-width: ${breakpoints.md}) {
      display: none;
    }
  }

  .mime-elements-headline-2 {
    font-size: ${asRem(35)};
    margin-bottom: -${asRem(15)};

    @media (min-width: ${breakpoints.md}) {
      font-size: ${asRem(40)};
    }

    @media (min-width: ${breakpoints.lg}) {
      font-size: ${asRem(45)};
    }
  }

  .mime-elements-paragraph {
    margin-bottom: ${asRem(24)};
  }
`;
